import { Routes, Route } from 'react-router-dom';
import { MainLayout, MinimalLayout, AdminLayout } from './layouts';
import { ScrollToTop } from './ScrollToTop';

// Import views from features
import { PropertiesList, PropertyDetails, PropertiesErrorBoundary } from '@features/properties';
import { Purchase } from '@features/purchase-journey';

// Admin pages placeholder
const AdminDashboard = () => (
  <div className="p-4">
    <h1 className="text-2xl font-bold">لوحة التحكم</h1>
    <p className="text-gray-600 mt-2">مرحباً بك في لوحة التحكم</p>
  </div>
);

const AdminProperties = () => (
  <div className="p-4">
    <h1 className="text-2xl font-bold">إدارة العقارات</h1>
    <p className="text-gray-600 mt-2">قائمة العقارات</p>
  </div>
);

const AdminSettings = () => (
  <div className="p-4">
    <h1 className="text-2xl font-bold">الإعدادات</h1>
    <p className="text-gray-600 mt-2">إعدادات النظام</p>
  </div>
);

/**
 * Application routes
 */
export function AppRoutes() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Public routes with main layout */}
        <Route element={<MainLayout />}>
          <Route path="/" element={
            <PropertiesErrorBoundary>
              <PropertiesList />
            </PropertiesErrorBoundary>
          } />
          <Route path="/properties/:id" element={
            <PropertiesErrorBoundary>
              <PropertyDetails />
            </PropertiesErrorBoundary>
          } />
        </Route>

        {/* Purchase flow with minimal layout */}
        <Route element={<MinimalLayout />}>
          <Route path="/purchase/:propertyId" element={<Purchase />} />
        </Route>

        {/* Admin routes with admin layout */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="properties" element={<AdminProperties />} />
          <Route path="settings" element={<AdminSettings />} />
        </Route>

        {/* 404 fallback */}
        <Route
          path="*"
          element={
            <MainLayout>
              <div className="min-h-screen flex items-center justify-center">
                <div className="text-center">
                  <h1 className="text-4xl font-bold text-slate-900 mb-4">404</h1>
                  <p className="text-slate-600">الصفحة غير موجودة</p>
                </div>
              </div>
            </MainLayout>
          }
        />
      </Routes>
    </>
  );
}
